import React, { useEffect, useRef, useState } from "react";
import AgoraRTC, {
  IAgoraRTCClient,
  ILocalAudioTrack,
  ILocalVideoTrack,
  IRemoteAudioTrack,
} from "agora-rtc-react";
import {
  agoraCheckSessionEndedPodcastService,
  agoraEndSessionPodcastService,
  agoraInfoPodcastService,
  agoraLiveCommentsPodcastService,
  agoraRequestListingPodcastService,
  agoraSessionDetailPodcastService,
  getParticipantsPodcastService,
  rejectRequestPodcastService,
  rightsAllowPodcastService,
  rightsRevokePodcastService,
} from "../services/VideoCallService";
import { useSearchParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import AppMessage from "../Constant/AppMessage";
import { AgoraAppId } from "../utils/config";
import {
  ICheckSessionEndResponse,
  IIparticipantsListUserResponse,
  IMessage,
  IMessageResponse,
  IParticipantsListUser,
  IRejectResponse,
  IRequestListResponse,
  IRequestUser,
  IRightsAllowResponse,
  IRightsRevokeResponse,
  ISessionDetailResponse,
  ISessionDetailResult,
  ISessionEndResponse,
  ISessionResponse,
  ISessionResult,
} from "../@types/VideoCallTypes";
import Podcast from "../components/Podcast";
import {
  getErrorDataCase,
  getVolumeCategory,
  VolumeCategory,
} from "../utils/CommonFunction";

let intervalRefSessionDetail: ReturnType<typeof setInterval>;
let intervalRefRequestListing: ReturnType<typeof setInterval>;
let intervalRefComments: ReturnType<typeof setInterval>;
let intervalRefgetParticipants: ReturnType<typeof setInterval>;

type RemoteUser = {
  uid: string;
  audioTrack?: IRemoteAudioTrack;
  audioEnabled: boolean;
};

// Whether screen sharing is active
let isScreenSharing: boolean = false;

// Whether the remote user's video is turned on
let isRemoteVideoOn: boolean = false;

// Whether the remote user's audio is turned on
let isRemoteAudioOn: boolean = false;

// Unique session ID, null if no session is active
let sessionId: any = "";

// Stores the list of remote users in the call
// Each user has a unique UID and may have video, audio, and screen tracks
let remoteUsers: RemoteUser[] = [];

type ActiveSpeaker = {
  uid: string | number;
  level: number;
  category: VolumeCategory;
};
const PodcastScreen = () => {
  // Stores the currently selected user in the call
  // "local" represents the current user, and a number represents a remote user's UID
  const [selectedUser, setSelectedUser] = useState<"local" | number>("local");

  // Manages the active tab in the UI
  // Default is "all", but it could be switched based on user interaction
  const [activeTab, setActiveTab] = useState<string>("all");

  // States for tracking microphone and camera status
  const [micOn, setMic] = useState<boolean>(true);

  // States for tracking the connection and calling status
  const [isConnected, setIsConnected] = useState<boolean>(false);
  const [calling, setCalling] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [showError, setShowError] = useState<boolean>(false);

  // States for tracking local media tracks (microphone, camera, screen sharing)
  const [localMicrophoneTrack, setLocalMicrophoneTrack] =
    useState<ILocalAudioTrack | null>(null);

  // State for managing UI state (e.g., error messages, permissions)
  const [showPermissionError, setShowPermissionError] =
    useState<boolean>(false);

  //concent modal states
  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);

  // State for managing errors and messages
  const [error, setError] = useState<string | null>("");
  const [msg, setMsg] = useState<string | null>("");

  // State for managing student and tutor profiles
  const [celebProfile, setCelebProfile] = useState<ISessionResult | null>(null);
  const [sessionDetail, setSessionDetail] =
    useState<ISessionDetailResult | null>(null);

  const [participantsList, setParticipantsList] = useState<IParticipantsListUser[] | null>(null);

  const [requestList, setRequestList] = useState<IRequestUser[]>([]);

  const [commentList, setCommentList] = useState<IMessage[]>([]);

  const [activeSpeakers, setActiveSpeakers] = useState<ActiveSpeaker[]>([]);
  // Reference to the Agora engine (RTC client)
  const agoraEngineRef = useRef<IAgoraRTCClient>();

  // UI and permission management
  const [hasPermissions, setHasPermissions] = useState<boolean>(false);
  const [permissionsGranted, setPermissionsGranted] = useState({
    microphone: false,
  });
  const [refrsh, setRefresh] = useState<boolean>(false);

  // State for search parameters (URL search query)
  const [searchParams, setSearchParams] = useSearchParams();

  const encString: any = searchParams.get("data")
    ? searchParams.get("data")
    : "";

  // Check for media permissions
  useEffect(() => {
    checkPermissions().then((hasPermission) => {
      if (hasPermission) {
        setHasPermissions(true);
      }
    });
  }, []);

  // Fetch Agora user info if token and permissions are available
  useEffect(() => {
    if (hasPermissions) {
      fetchAgoraUserInfo();
    }
  }, [hasPermissions]);

  // Initialize Agora client
  useEffect(() => {
    agoraEngineRef.current = AgoraRTC.createClient({
      mode: "live",
      codec: "vp8",
      role: "host",
    });
  }, []);

  // Set up Agora event listeners
  useEffect(() => {
    if (hasPermissions) {
      // Event listeners for Agora RTC client
      agoraEngineRef.current?.on(
        "user-joined",
        (user: any, mediaType: string) => {
          handleUserPublished(user, mediaType);
        }
      );

      agoraEngineRef.current?.on("user-left", handleUserUnpublished);

      // Event listener for remote user published
      agoraEngineRef.current?.on("user-published", handleUserPublished);

      agoraEngineRef.current?.on("user-unpublished", remoteUserUnpublished);
      // agoraEngineRef.current?.enableAudioVolumeIndicator();

      // agoraEngineRef.current?.on("volume-indicator", (volumes: any[]) => {
      //   if (!volumes.length) return;

      //   const active: ActiveSpeaker[] = volumes.map((v) => ({
      //     uid: v.uid,
      //     level: v.level,
      //     category: getVolumeCategory(v.level),
      //   }));

      //   setActiveSpeakers(active);
      // });
      return () => {
        // Cleanup
        agoraEngineRef.current?.removeAllListeners();
      };
    }
  }, [hasPermissions]);

  const remoteUserUnpublished = (user: any, mediaType: string) => {
    const uid = user.uid.toString();
    if (mediaType === "audio") {
      remoteUsers = remoteUsers.map((remoteUser) => {
        if (remoteUser.uid === uid) {
          return {
            ...remoteUser,
            audioTrack: undefined,
            audioEnabled: false,
          };
        }
        return remoteUser;
      });
      setRefresh((prev) => !prev);
    }
  };
  // Api calls

  const fetchAgoraUserInfo = async () => {
    try {
      let data = {
        enc: encString,
      };
      let response: ISessionResponse = await agoraInfoPodcastService(data);
      if (response.result) {
        setMsg(AppMessage.waitMsg);
        setCelebProfile(response.result);
        global.authToken = response.result.jwtToken;
        sessionId = response.result.sessionId;
        const channel = response.result.channelName;
        const token = response.result.token;
        const tutorUid = response.result.userId;
        await new Promise((resolve) => setTimeout(resolve, 3000));

        let isEnded = await checkSessionEnded();
        if (!isEnded) {
          handleJoinChannel(tutorUid, token, channel);
          agoraLiveComments();
          intervalRefComments = setInterval(agoraLiveComments, 5000);
        } else {
          handleLeaveChannel();
        }
      }
    } catch (err) {
      setError(getErrorDataCase(err));
      console.log(AppMessage.requestFailed);
    }
  };

  const getSessionDetail = async () => {
    try {
      let data = {
        session_id: sessionId,
      };
      let response: ISessionDetailResponse =
        await agoraSessionDetailPodcastService(data);
      if (response.result) {
        setSessionDetail(response.result);
        setRefresh((prev) => !prev);
      }
    } catch (err) {
      setError(getErrorDataCase(err));
    }
  };
  const getParticipants = async () => {
    try {
      let data = {
        session_id: sessionId,
      };
      let response: IIparticipantsListUserResponse =
        await getParticipantsPodcastService(data);
      if (response.result) {
        setParticipantsList(response.result.content);
        setRefresh((prev) => !prev);
      }
    } catch (err) {
      setError(getErrorDataCase(err));
    }
  };

  const checkSessionEnded = async () => {
    try {
      let data = {
        session_id: sessionId,
      };
      let response: ICheckSessionEndResponse =
        await agoraCheckSessionEndedPodcastService(data);

      if (response.result === false) {
        return response.result;
      } else {
        setError(AppMessage.sessionExpire);
        setMsg("");
        return true;
      }
    } catch (err: any) {
      setError(getErrorDataCase(err));
      setMsg("");
      return true;
    }
  };
  const requestRejectRequest = async (userId: number) => {
    try {
      setLoading(true);

      let data = {
        session_id: sessionId,
        userId: userId,
      };
      let response: IRejectResponse = await rejectRequestPodcastService(data);
      if (response.result) {
        console.log("User granted rights successfully");
        getRequestListing();
      }
    } catch (err) {
      setError(getErrorDataCase(err));
    } finally {
      setLoading(false);
    }
  };
  const getRequestListing = async () => {
    try {
      let data = {
        session_id: sessionId,
      };
      let response: IRequestListResponse =
        await agoraRequestListingPodcastService(data);
      if (response.result) {
        setRequestList(response.result);
      }
    } catch (err) {
      setError(AppMessage.requestFailed);
    }
  };
  const requestRightsAllow = async (userId: number) => {
    try {
      setLoading(true);

      console.log("Accepted", userId);

      let data = {
        session_id: sessionId,
        userId: userId,
      };
      let response: IRightsAllowResponse = await rightsAllowPodcastService(
        data
      );
      if (response.result) {
        console.log("User granted rights successfully");

        getSessionDetail();
        getRequestListing();
      }
    } catch (err: any) {
      setError(getErrorDataCase(err));
      onPressShowError();
    } finally {
      setLoading(false);
    }
  };

  const requestRightsRevoke = async (userId: number) => {
    try {
      setLoading(true);
      console.log("Reject", userId);

      let data = {
        session_id: sessionId,
        userId: userId,
      };
      let response: IRightsRevokeResponse = await rightsRevokePodcastService(
        data
      );
      if (response.result) {
        console.log("User rights revoke successfully");
        getSessionDetail();
        getRequestListing();
      }
    } catch (err: any) {
      setError(getErrorDataCase(err));
      onPressShowError();
    } finally {
      setLoading(false);
    }
  };

  const agoraLiveComments = async () => {
    try {
      let data = {
        session_id: sessionId,
      };
      let response: IMessageResponse = await agoraLiveCommentsPodcastService(
        data
      );
      if (response.result) {
        setCommentList(response.result);
      }
    } catch (err: any) {
      setError(getErrorDataCase(err));
    }
  };
  const onPressLeaveCall = async () => {
    try {
      let data = {
        session_id: sessionId,
      };
      let response: ISessionEndResponse = await agoraEndSessionPodcastService(
        data
      );
      if (response.result) {
        setMsg(AppMessage.CallEnd);
        setError("");
        handleLeaveChannel();
      }
    } catch (err: any) {
      setError(getErrorDataCase(err));
      onPressShowError();
    } finally {
      setShowConfirmModal(false);
    }
  };

  const checkPermissions = async () => {
    try {
      // Check microphone permission
      const micStream = await navigator.mediaDevices.getUserMedia({
        audio: true,
      });
      micStream.getTracks().forEach((track) => track.stop());

      setPermissionsGranted({ microphone: true });
      return true;
    } catch (error) {
      console.error("Permission error:", error);
      setShowPermissionError(true);
      setPermissionsGranted({ microphone: false });
      return false;
    }
  };

  const handleJoinChannel = async (
    tutorUid: number | null,
    token: string,
    channel: string
  ) => {
    console.log("handleJoinChannel", tutorUid, token, channel);
    if (hasPermissions) {
      try {
        agoraEngineRef.current?.on("connection-state-change", (state) => {
          console.log("Connection state changed:", state);
          if (state === "CONNECTED") {
            setIsConnected(true);
          } else {
            setIsConnected(false);
          }
        });
        setMsg("");
        setError("");

        let res = await agoraEngineRef.current?.join(
          AgoraAppId,
          channel,
          token,
          tutorUid
        );

        // Create Local Tracks (Microphone and Camera)
        const micTrack = await AgoraRTC.createMicrophoneAudioTrack();
        setLocalMicrophoneTrack(micTrack);

        if (!agoraEngineRef.current?.uid) return;
        await agoraEngineRef.current?.publish([micTrack]);

        setCalling(true);

        // Api call getSessionDetail

        getSessionDetail();
        intervalRefSessionDetail = setInterval(getSessionDetail, 10000);

        // Api call getRequestListing
        getRequestListing();
        intervalRefRequestListing = setInterval(getRequestListing, 10000);
      } catch (error) {
        setError(AppMessage.requestFailed);
        // handleLeaveChannel();
        console.error("Error joining channel:", error);
      }
    } else {
      setShowPermissionError(true);
      setMsg("");
    }
  };

  const onPressMic = (val: boolean) => {
    setMic(val);
    if (localMicrophoneTrack) {
      if (val) {
        localMicrophoneTrack.setVolume(100); // Unmute
      } else {
        localMicrophoneTrack.setVolume(0); // Mute
      }
    }
  };

  const handleLeaveChannel = async () => {
    try {
      if (localMicrophoneTrack) {
        localMicrophoneTrack.stop();
        localMicrophoneTrack.close();
      }

      await agoraEngineRef.current?.leave();

      if (intervalRefSessionDetail) clearInterval(intervalRefSessionDetail);
      if (intervalRefRequestListing) clearInterval(intervalRefRequestListing);
      if (intervalRefComments) clearInterval(intervalRefComments);
      if (intervalRefgetParticipants) clearInterval(intervalRefgetParticipants);

      setIsConnected(false);
      setCalling(false);
      setLocalMicrophoneTrack(null);
      setRequestList([]);
      setSessionDetail(null);
      remoteUsers = [];
      setCommentList([]);
    } catch (error) {
      console.error("Error leaving channel:", error);
    }
  };

  const onPressCalling = (val: boolean) => {
    if (calling) {
      setShowConfirmModal(true); // If already calling, end the call
    }
  };

  const onPressPermissionsError = () => {
    setShowPermissionError(!showPermissionError);
  };

  const handleUserPublished = async (user: any, mediaType: string) => {
    const uid = user.uid.toString();
    const existingUserIndex = remoteUsers.findIndex((u) => u.uid === uid);

    let updatedUser = {
      uid,
      audioTrack: remoteUsers[existingUserIndex]?.audioTrack,
      audioEnabled: remoteUsers[existingUserIndex]?.audioEnabled || false,
    };

    if (mediaType === "audio" && user.hasAudio) {
      await agoraEngineRef.current?.subscribe(user, "audio");
      updatedUser.audioTrack = user.audioTrack as IRemoteAudioTrack;
      if (updatedUser.audioTrack) {
        updatedUser.audioEnabled = true;
      }
      user.audioTrack?.play();
    }

    if (existingUserIndex > -1) {
      const updatedUsers = [...remoteUsers];
      updatedUsers[existingUserIndex] = updatedUser;
      remoteUsers = updatedUsers;
    } else {
      remoteUsers = [...remoteUsers, updatedUser];
    }

    setRefresh((prev) => !prev);
  };

  // Handle a remote user unpublished (e.g., leaving the call or stopping the video)
  const handleUserUnpublished = (user: any) => {
    console.log("Remote user unpublished:", remoteUsers, user.uid);

    remoteUsers = remoteUsers.filter((u) => u.uid !== user.uid.toString());
    setRefresh((prev) => !prev);
  };

  const onPressClose = () => {
    setShowConfirmModal(!showConfirmModal);
  };

  const onPressConfirm = () => {
    onPressLeaveCall();
  };

  const onPressSelectedUser = (val: "local" | number) => {
    setSelectedUser(val);
  };

  const onPressTabs = (val: string) => {
    setActiveTab(val);
    if (val == "participant") {
      getParticipants();
      intervalRefgetParticipants = setInterval(getParticipants, 60000);
    } else {
      setParticipantsList(null)
      if (intervalRefgetParticipants) clearInterval(intervalRefgetParticipants);
    }
  };
  const onPressShowError = () => {
    setShowError(!showError);
  };
  return (
    <Podcast
      isConnected={isConnected}
      remoteUsers={remoteUsers}
      onPressCalling={onPressCalling}
      onPressMic={onPressMic}
      calling={calling}
      isScreenSharing={isScreenSharing}
      micOn={micOn}
      localMicrophoneTrack={localMicrophoneTrack}
      permissionsGranted={permissionsGranted}
      showPermissionError={showPermissionError}
      onPressPermissionsError={onPressPermissionsError}
      isRemoteAudioOn={isRemoteAudioOn}
      isRemoteVideoOn={isRemoteVideoOn}
      error={error}
      msg={msg}
      celebProfile={celebProfile}
      sessionDetail={sessionDetail}
      onPressClose={onPressClose}
      onPressConfirm={onPressConfirm}
      showConfirmModal={showConfirmModal}
      selectedUser={selectedUser}
      onPressSelectedUser={onPressSelectedUser}
      onPressTabs={onPressTabs}
      activeTab={activeTab}
      requestList={requestList}
      requestRightsAllow={requestRightsAllow}
      requestRightsRevoke={requestRightsRevoke}
      loading={loading}
      requestRejectRequest={requestRejectRequest}
      onPressShowError={onPressShowError}
      showError={showError}
      commentList={commentList}
      activeSpeakers={activeSpeakers}
      participantsList={participantsList}
    />
  );
};
export default PodcastScreen;
